import { AppState } from '../reducer'

export const notificationsSelector = (state: AppState) => state.notifications.items
